import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { SchoolClass } from 'src/modules/enaio-certificates/shared/school-class.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ClassRegisterSettings } from '../../shared/class-register-settings.entity';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';

@Component({
    selector: 'enaio-certificates-main',
    templateUrl: './certificates-main.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CertificatesMainComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    schoolClasses: SchoolClass[] = [];
    settings: ClassRegisterSettings;
    isHalfYear: boolean;
    userName = "";
    isAdmin = false;

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.isHalfYear = EnaioCertificatesTools.getCurrentIsHalfYear();
        this.isAdmin = this.service.isAdminForCertificates();
        this.app.updateNavigation("Zeugnisse", [this.service.getHomeCertificates()]);
        this.schoolClasses = (await this.service.restGetSchoolClasses(EnaioCertificatesTools.getCurrentSchoolYear())).filter(sc => this.hasPermission(sc) && sc.isForCertificates());
        this.settings = await this.service.restGetClassRegisterSettings(EnaioCertificatesTools.getCurrentYear(), this.isHalfYear);
        this.userName = this.app.getUserName();
        return true;
    }

    getExistingGrades(): number[] {
        return Arrays.getUnique(this.schoolClasses.map(sc => sc.grade));
    }

    async adminClick(): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "globalsettings"]);
    }

    hasPermission(sc: SchoolClass): boolean {
        return true; //this.isAdmin || sc.hasPermission(this.userName) || this.settings != null && sc.isManager(this.userName, this.settings);
    }
}
